import axios from 'axios';
const api = axios.create({ baseURL: '/api' });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('fb_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const setToken = (token) => localStorage.setItem('fb_token', token);
export const clearToken = () => localStorage.removeItem('fb_token');
export default api;
